// Do not remove, this is a shim for react-native-add-calendar-event, which doesn't support web
export const presentEventCreatingDialog = () => {}
